import React, { useState, useMemo, useEffect } from 'react'
import { Detail } from '@tecuity/granite-ui/Detail'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import PencileIcon from '@tecuity/sos-icons/react/pencil-solid'
import './ReceiptValidation.scss'
import format from 'date-fns/format'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import { useGetDLNLink } from '../../../Utilities/Utilities'

const ReceiptCharge = ({ chargeItem, updateItem, chargeIndex, isEditable, deleteItem }) => {
  const [expanded, setExpanded] = useState(false)
  const [item, setItem] = useState(chargeItem)

  useEffect(() => {
    setItem(chargeItem)
  }, [chargeItem])

  const userCanEdit = useMemo(() => {
    return isEditable
  }, [isEditable])

  const toggleEdit = () => {
    if (updateItem) updateItem(item, chargeIndex)
  }

  const batch = useMemo(() => {
    if (item.BatchResponse) return item.BatchResponse
    return {}
  }, [item])

  return (
    <React.Fragment>
      <DetailCard
        label={
          <div
            style={{
              display: 'flex',
              gap: '10px',
              flexDirection: 'row',
              alignItems: 'center',
              color: 'white',
            }}
          >
            <p>DLN #:</p>
            {useGetDLNLink(item.DLNNum, 'dln-label-override')}
          </div>
        }
        className="detailsCard"
      >
        {/* <div className="floating-card-variable-width"> */}
        <div className={true ? 'floating-card-variable-width lock-card' : ''}>
          <div className="floating-card-header">
            <Detail
              label="Charge Type"
              children={item.Type ? item.Type.Description : 'no type defined'}
              fontSize="small"
            />
            <Detail label="Reference #" children={item.RefCheckNum} fontSize="small" />

            <div className="floating-card-header currency">
              <Detail
                label="Amount"
                children={`$${(Number(item.Amount) || 0)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                fontSize="small"
              />
              <Detail label="Qty" children={item.Quantity} fontSize="small" />
              <Detail
                label="Total"
                children={`$${(Number(item.Amount) * Number(item.Quantity) || 0)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                fontSize="small"
                className="charge-value"
              />
              {userCanEdit ? (
                <span title={'Delete Charge'}>
                  <IconButton
                    onClick={() => {
                      deleteItem(item, chargeIndex, 'Charge')
                    }}
                    icon={<CrossHeavy />}
                    label="Delete Charge"
                    customCss={'padding: 5px !important; margin-left: 4px;'}
                  />
                </span>
              ) : null}
              {userCanEdit ? (
                <span title={'Edit Charge Details'}>
                  <IconButton
                    onClick={toggleEdit}
                    icon={<PencileIcon />}
                    label="Edit Charge Details"
                    customCss={'padding: 5px !important; margin-left: 4px;'}
                  />
                </span>
              ) : null}
              <span title={`${expanded ? 'Hide' : 'View'} Charge Details`}>
                <IconButton
                  onClick={() => {
                    setExpanded(!expanded)
                  }}
                  icon={expanded ? <CaretUpIcon /> : <CaretDownIcon />}
                  label="View Charge Details"
                  customCss={'padding: 5px !important; margin-left: 4px;'}
                />
              </span>
            </div>
          </div>

          <div className="floating-card-body">
            <div className="card-details">
              {expanded && (
                <React.Fragment>
                  <div className="row card-row">
                    <Detail label="Description" children={item.Description} fontSize="small" />
                  </div>
                  <div className="row card-row">
                    <div className="num-and-date">
                      <Detail label="Batch #" children={batch.BatchNum} fontSize="small" />
                      <Detail
                        label="Batch Date"
                        children={
                          batch.CreatedAt ? format(new Date(batch.CreatedAt), 'MM/dd/yyyy') : null
                        }
                        fontSize="small"
                      />
                    </div>
                    <Detail label="Processed By" children={item.ProcessedBy} fontSize="small" />
                  </div>
                  <div className="row card-row">
                    <div className="num-and-date">
                      <Detail label="Post #" children={batch.PostNum} fontSize="small" />
                      <Detail
                        label="Post Date"
                        children={
                          batch.PostDate ? format(new Date(batch.PostDate), 'MM/dd/yyyy') : null
                        }
                        fontSize="small"
                      />
                    </div>
                    <div />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        {/* </div> */}
      </DetailCard>
    </React.Fragment>
  )
}

export default ReceiptCharge
